import changeSelectedChannelToPreselectedChannel from './changeSelectedChannelToPreselected';
import fetchCurrentUserChannels from './fetchCurrentUserChannels';

const handleChannelJoined =
  ({ channelId }) =>
  async (dispatch) => {
    dispatch(fetchCurrentUserChannels({ specificChannelId: channelId }));
    dispatch(changeSelectedChannelToPreselectedChannel({ channelId }));
  };

export default handleChannelJoined;
